import axios from 'src/request';

export function getMenus() {
  return axios({
    method: 'get',
    url: '/oa-real-estate/api/v1/auth/access',
  });
}

export function getUserInfo() {
  return axios({
    method: 'get',
    url: '/oa-real-estate/api/v1/auth/userInfo',
  });
}

export function getAccountBalance() {
  return axios({
    method: 'get',
    url: '/oa-real-estate/api/v1/pay/account/balance',
  });
}

export default {};
